import Notfound from "components/templates/nopage/Notfound";
import { EULAModal } from "pages/terms/text/EULAModal";
import { SLAModal } from "pages/terms/text/SLAModal";
import React from "react";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import StatementPolicy from "./text/StatementPolicy";

interface Props {
  pathname: string;
}
export default function TermsPresenter(props: Props) {
  if (props.pathname.includes("eula"))
    return (
      <Container>
        <Title>myDW End User License Agreement</Title>
        <EULAModal />
      </Container>
    );
  if (props.pathname.includes("sla"))
    return (
      <Container>
        <Title>myDW Service Level Agreement</Title>
        <SLAModal />
      </Container>
    );
  if (props.pathname.includes("cookie-policy"))
    return (
      <Container>
        <Title>DW® Cookie Policy</Title>
        <StatementPolicy />
      </Container>
    );
  return <Notfound />;
}

const Title = styled.h1`
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid ${COLORS.BUTTONS1};
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 500;
  font-size: ${calcRem(24)};
`;

const Container = styled.div`
  background-color: ${(props) => props.theme.COLORS.BG};
  white-space: pre-wrap;
  color: ${({ theme }) => theme.COLORS.WHITE};
  padding: 0 20px;
  width: 100%;
`;
